export enum UserRole {
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
  CLEVERPE_USER = 'cleverpeuser'
}

// Permission type definition
export type Permission =
  | 'view-dashboard'
  | 'manage-dashboard'
  | 'view-manage-admin'
  | 'manage-manage-admin'
  | 'view-cleverpe-supply+'
  | 'manage-cleverpe-supply+'
  | 'view-partner'
  | 'manage-partner'
  | 'view-merchant'
  | 'manage-merchant'
  | 'view-customer'
  | 'view-scheme'
  | 'manage-scheme'
  | 'view-product'
  | 'manage-product'
  | 'view-brand'
  | 'manage-brand'
  | 'view-order'
  | 'manage-order'
  | 'view-gateway-order'
  | 'manage-gateway-order'
  | 'view-cancel-order'
  | 'manage-cancel-order'
  | 'manage-transaction'
  | 'view-pre-approvals-report'
  | 'view-settlements-report'
  | 'view-merchant-data-report'
  | 'view-store-approvals'
  | 'view-grievance-redressals'
  | 'manage-grievance-redressals'
  | 'manage-store-approvals'
  | 'view-category'
  | 'view-calculator'
  | 'view-external-api-logs'
  | 'manage-category'
  | 'view-scheme-bucket'
  | 'manage-scheme-bucket'
  | 'view-kycpending-merchant'
  | 'view-lender-merchant-approval';

export interface User {
  name: string;
  email: string;
  role: UserRole;
  mobileNo: string;
  suspended: boolean;
  activated: boolean;
  lastLogin: string;
  dashPermissions?: Permission[]; // Add permissions array
  groups?: string[]; // Add groups array for cleverpeuser role
  lender?: string[]; // Add lender field for cleverpeuser role
} 